// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormRadio_wrapper","disabled":"FormRadio_disabled"};